import { render, staticRenderFns } from "./DataIndex.vue?vue&type=template&id=356173e7&scoped=true"
import script from "./DataIndex.vue?vue&type=script&lang=js"
export * from "./DataIndex.vue?vue&type=script&lang=js"
import style0 from "./DataIndex.vue?vue&type=style&index=0&id=356173e7&prod&scoped=true&lang=less"
import style1 from "./DataIndex.vue?vue&type=style&index=1&id=356173e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356173e7",
  null
  
)

export default component.exports